var common = require("../utiles/common");
var service = require("../utiles/service");
var layUtils = require("../utiles/layUtils");

module.exports = {
  register: function () {
    document.createElement("uch");
    ko.components.register("uch", {
      viewModel: function (params) {
        var $this = this;
        $this.switchUser = function () {
          var data = common.fetch("/auth/getUser", { type: "GET" }).data;
          $this.user = data;
          common.initStorage(data);
          sessionStorage.setItem("firstTime", "2");
        };
        // 判断是否刷新或者退出登录
        if (
          sessionStorage.getItem("firstTime") === "1" ||
          !sessionStorage.getItem("firstTime")
        ) {
          $this.switchUser();
        } else {
          $this.user = common.getStorage().user;
        }
        $this.hideFun = [];
        if (localStorage.getItem("authNode")) {
          var authNode = JSON.parse(localStorage.getItem("authNode"));
          console.log(authNode);
          if (authNode.hideFun && authNode.hideFun.length > 0) {
            $this.hideFun = authNode.hideFun;
          }
        }
        $this.formData = {
          fields: [
            {
              display: "选择身份",
              type: "select",
              options:
                $this.user.subjectList && $this.user.subjectList.length > 0
                  ? $this.user.subjectList
                  : [],
              code: "id",
              name: "orgNameAndUserName",
              fieldName: "subjectId",
              rules: ["required"],
            },
          ],
        };

        $this.updateTotal = function () {
          $this.total = ko.observable(0);
        };
        $this.updateTotal();
        console.log($this.user);
        $this.list = ko.observable("/public/images/top_list1.png");
        $this.jia = ko.observable("/public/images/top_jia1.png");
        $this.sc = ko.observable("/public/images/top_sc1.png");
        $this.zu = ko.observable("/public/images/top_zu1.png");
        $this.isActive = ko.observable();
        if (
          location.hash == "#/appList" ||
          location.hash == "#/appSort" ||
          location.hash.indexOf("appConfig") != -1 ||
          location.hash.indexOf("manageAuth") != -1 ||
          location.hash.indexOf("editAttr") != -1 ||
          location.hash.indexOf("recordIndex") != -1
        ) {
          $this.isActive("appList");
        } else if (
          location.hash == "#/workflow" ||
          location.hash == "#/accountApply" ||
          location.hash.indexOf("workflow") != -1
        ) {
          $this.isActive("workflow");
        } else {
          $this.isActive(location.hash.split("/")[1]);
        }
        $this.userDropMenu = {
          isDropMenuDisplay: ko.observable(false),
          className: "userDropMenu",
          items: [
            {
              icon: "\ue681",
              name: commonLocal.menu.User,
              action: function () {
                common.redirectTo("/#/userInfo");
              },
            },
            {
              icon: "\ue621",
              name: commonLocal.menu.password,
              action: function () {
                common.redirectTo("/#/updatePassword");
              },
            },
            {
              icon: "\ue621",
              name: "生成二维码",
              action: function () {
                common.redirectTo("/#/qrcode");
              },
            },
            { name: "split" },
            {
              icon: "\ue60d",
              name: commonLocal.menu.out,
              action: function () {
                common.fetch("/auth/logout", {
                  method: "POST",
                  success: function (data) {
                    if (data.redirectUrl) {
                      common.redirectTo(data.redirectUrl);
                    } else {
                      localStorage.clear();
                      sessionStorage.clear();
                      sessionStorage.setItem("spnego", true);
                      sessionStorage.setItem("isWinLogout", true);
                      common.redirectTo("/#/");
                    }
                  },
                });
              },
            },
          ],
        };

        $this.userList = ko.observableArray();

        if (
          $this.user.identitySwitch &&
          $this.user.subjectList &&
          $this.user.subjectList.length > 0
        ) {
          $this.userDropMenu.items.unshift({
            icon: "\ue681",
            name: "身份切换",
            action: function () {
              $this.userList($this.user.subjectList);
            },
          });
        }
        $this.workDropMenu = {
          isDropMenuDisplay: ko.observable(false),
          className: "userDropMenu",
          items: [
            {
              name: "流程审批",
              action: function () {
                common.redirectTo("/#/workflow/pending");
              },
            },
          ],
        };
        $this.triggerUserDropMenu = function () {
          var old = $this.userDropMenu.isDropMenuDisplay();
          $this.userDropMenu.isDropMenuDisplay(!old);
        };
        $this.triggerWorkDropMenu = function () {
          var old = $this.workDropMenu.isDropMenuDisplay();
          $this.workDropMenu.isDropMenuDisplay(!old);
        };
        $this.active = ko.observable("");
        $this.setId = function (id) {
          console.log(id);
          $this.active(id);
        };
      },
      template: require("./UserCenterHeader.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/template/UserCenterHeader.js
// module id = 101
// module chunks = 0